import React, {Component} from 'react';
import { NavBar, Session, NotificationsModal } from "../../components";
import {VIEW_NAME, config, SERVICE_API, DISPATCH_ID, SERVICE_RESPONSE, ROLES} from "../../libs/utils/Const";
import {connect} from 'react-redux';
import {ApiClient} from "../../libs/apiClient/ApiClient";
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import {CSVLink} from "react-csv";
import ExportReportPDFCardSaveds from '../../components/ExportReportPDFCardSaveds';

let apiClient = ApiClient.getInstance();

class AutoGestCartSavedView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            CartSaveds : [],
            order: {
                header: {},
                body: []
            },
            fechaInicio: '',
            fechaFinal: '',
            fechaActual: '',
            checkboxDataTables: (new Map(): Map<string, boolean>),
            responseArray :[],
            csvData : [],
            csvDatas : [],
        };
        this.table = null;
    };

    async componentDidMount(){
        let fechaInicio = moment(new Date()).format('YYYY-MM-DD');
        let fechaFinal = moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            fechaInicio,
            fechaFinal
        });
        setTimeout(() => {
            this.cargarDatos();
        }, 2000);
    };

    async cargarDatos (){
        const {enableSpinner} = this.props;
        const {fechaInicio,fechaFinal} = this.state;
        enableSpinner(true);
        let seller = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let data ={
            usuario : seller.salesPrson,
            fechaInicio : fechaInicio,
            fechaFinal : fechaFinal
        }
        // console.log('con<data',data);
        let newdatas = await apiClient.getAutoCartSaveds(data);
        
        if (newdatas.status === SERVICE_RESPONSE.SUCCESS) {
            let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        
            user = JSON.parse(user) || {}; 
            
            this.setState({
                CartSaveds : newdatas.data.list,
                CardName : user.CardName,
                fechaActual : moment(new Date()).format('YYYY-MM-DD')
            });
    
            this.table = $('#AutoCartsSaved').DataTable({
                "paging": false,
                "info": false,
                "searching": false
            });
            enableSpinner(false);
            return;
        }
        enableSpinner(false);
    };
    
    Details = async (valor, items, cardCode, shipAddress,datos) => {
        const {notificationReducer: { showAlert }, enableSpinner} = this.props;
        enableSpinner(true);
        
        let data = {
            usuario : cardCode,
            Items : items
        }

        let responses = await apiClient.getDetailsCartSaveds(data);
        
        let csvData = [];
        if (responses.data.list.length > 0 && responses.status === SERVICE_RESPONSE.SUCCESS) {
            // Descargar Excel detalle
            let infoCsv = responses.data.list;
            infoCsv.map((item)=>{
                let row ={
                    'Producto': item.ItemName,
                    'EAN': item.ItemCode,
                    'Cantidad': item.Quantity,
                    'Precio': config.general.currency +' '+ Number(Number(item.Price) + Number((item.Price * (18 / 100)))).toFixed(2),
                    'Precio Total': config.general.currency +' '+ Number((Number(item.Price) + Number((item.Price * (18 / 100)))) * parseInt(item.Quantity)).toFixed(2),
                    'Info': ' '
                }
                csvData.push(row);
            });
            
            for (let index = 0; index < 1; index++) {
                const element = csvData[index];
                let row ={
                    'Info': ' '
                }
                csvData.push(row);
            }
            let hoy = new Date();
            var Hora = hoy.getHours();
            var Min = hoy.getMinutes();
            var Fecha = hoy.toLocaleDateString();
                
            csvData[0].Info = "RUC "+datos.CardCode.substring(1)+"        "+Fecha+"-"+Hora+":"+Min+"hs        ";
            csvData[1].Info = "CLIENTE: "+datos.CardName+"        DIRECCIÓN DE ENVÍO: "+datos.DirEnvio;

            // Descargar Excel detalle
            this.setState({
                order: responses.data.list,
                U_Handel_Email: responses.data.datos[0].U_Handel_Email,
                U_Handel_Password : responses.data.datos[0].U_Handel_Password,
                shipAddress,
                idCarrito : valor,
                csvDatas : csvData
            });

            $('#autogestsave').modal('show');
            enableSpinner(false);
            return;
        }
        else{
            this.setState({
                order: [],
            });
            showAlert({ type: 'error', message: 'Los artículos guardados en este carrito ya no son visibles para este cliente',timeOut: 5000 });
            enableSpinner(false);
            return;
        }
    }

    handleInputDateInicio = event =>{
        let fechaInicio = event.nativeEvent.target.value;
        this.setState({
            fechaInicio
        });
    }

    handleInputDateFinal = event =>{
        let fechaFinal = event.nativeEvent.target.value;
        this.setState({
            fechaFinal
        });
    }

    getData = async () =>{        
        this.table.destroy();
        this.cargarDatos();
    }

    CheckboxActions = async (docEntryArray, action = null) => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;

        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        let creator;
        if (Number(creatorUser.U_FMB_Handel_Perfil) === 1) {
            creator = "Telemarketing:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 2) {
            creator = "Vendedor:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 3) {
            creator = "Administrador:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        }else{
            creator = "B2B:";
        }
        //Definicion del vendedor
        empID = empID ? empID.salesPerson : '';
        
        docEntryArray.map(nuevo =>{
        })
        let responseArray = [];

        for (let document in docEntryArray) {
            enableSpinner(true);

            let statusAuthorization: any = "";
            let message = "";
            if (action == 1) {
                message = "Creando orden de venta carrito de";
                statusAuthorization = 1;
            }
            let Documento = docEntryArray[document].CardName;
            showAlert({type: 'warning', message: message + ': ' + Documento, timeOut: 2500});

            let Id = docEntryArray[document].id;
            let response = "";

            if (action == 1) {
                
                let data = {
                    Id: docEntryArray[document].id,
                    CardCode: docEntryArray[document].CardCode,
                    CardName : docEntryArray[document].CardName,
                    objType: '17',
                    empID,
                    creator,
                    taxOnly: 0,
                    venta: '01',
                    Version : 'VerF: '+global.appVersion,                    
                    creatorUser,
                };
                
                response = await apiClient.createCartSaved(data);
                // return
                if(response.status === SERVICE_RESPONSE.SUCCESS){                    
                    await apiClient.deleteCartSaved(Id);
                }
            }

            enableSpinner(false);
            try {
                responseArray.push({
                    docNum: Documento,
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    message: '',
                });
            }
        }
        return responseArray;
    };

    async addToShopingCart(idCarrito){
        const {notificationReducer: {showAlert},configReducer,enableSpinner, setRememberUser,setUserSession,setRole,setToken} = this.props;
        const {order,U_Handel_Email,U_Handel_Password,shipAddress} = this.state;
        
        const orders = []; 

        for(var indice = 0; indice < order.length; indice++) {
            const arreglo = order[indice];
            let esDuplicado = false;
            for(var i = 0; i < orders.length; i++) {
                if (orders[i].ItemCode === arreglo.ItemCode) {
                    orders[i].Quantity += parseInt(arreglo.Quantity);
                    esDuplicado = true;
                    break;
                }
            }
            if (!esDuplicado) {
                orders.push(arreglo);
            }
        }

        let items = [];
        orders.map(item => {
            if(item.ItemCode !== "ENVIO"){
                items.push({ItemCode: item.ItemCode, quantity: parseInt(item.Quantity)});
            }
        });
        
        enableSpinner(true);

        // Agregar cliente 
        let user = {
            email: U_Handel_Email,
            password: U_Handel_Password,
        };

        let response = await apiClient.login(user,'');
        if(response.status === 0){
            return;
        }

        let vendedor = {
            salesPerson: "0",
            firstName: "Vendedor",
            lastName: "Desde cliente"
        };
        
        enableSpinner(true);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            let user = response.data.user;
            let token = response.data.token;
            let remember = true;
            
            localStorage.setItem(config.general.localStorageNamed + 'Token', JSON.stringify(token));
            localStorage.setItem(config.general.localStorageNamed + 'Role', ROLES.CLIENT);
            localStorage.setItem(config.general.localStorageNamed + 'CurrentUser', JSON.stringify(user));
            localStorage.setItem(config.general.localStorageNamed + 'Vendor', JSON.stringify(vendedor));
            localStorage.setItem(config.general.localStorageNamed + 'RememberUser', remember );
            localStorage.setItem(config.general.localStorageNamed + 'ShipAddress', shipAddress );

            setRole(ROLES.CLIENT);
            setToken(token);
            setUserSession(user);
            setRememberUser(remember);

            let responsesd = await apiClient.updateShoppingCartLocal(items);

            localStorage.removeItem(config.general.localStorageNamed + 'shoppingCart');

            enableSpinner(false);
            setTimeout(async ()=> {
                if(responsesd.data.value > 0){
                    $('#autogestsave').modal('hide');
                    await apiClient.deleteCartSaved(idCarrito);
                    showAlert({type: 'success', message: ' Agregado a carrito correctamente ', timeOut: 0});
                    configReducer.history.goShoppingCart();
                }else{
                    configReducer.history.goHome();
                }
            },50);
            
            return;
        }
        // Agregar cliente
        enableSpinner(false);
    }

    GenerateOrderMasive = async response => {
        const {notificationReducer: {showAlert}} = this.props;
        const {CartSaveds, checkboxDataTables} = this.state;
        let docEntryArray = [];
        let responseArray = [];
        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(CartSaveds[id]);
            }
        }
        $('#estasSeguroModalOrder').modal('hide');
        if(docEntryArray.length>0){
            responseArray = await this.CheckboxActions(docEntryArray,1);
            this.toggleDocumentSelectedAll(false);
            
            this.setState({
                checkboxDataTables: (new Map(): Map<string, boolean>),
                responseArray 
            })
            $('#notificationsModal').modal('show');
            this.table.destroy();
            this.cargarDatos();

        } else{
            showAlert({type: 'error', timeOut: 2000, message: "Seleccione un carrito"});
            return;
        }
    };

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id)); // toggle
            return {checkboxDataTables};
        });
    };

    toggleDocumentSelectedAll = (action) => {
        const {CartSaveds} = this.state;
        let newCheckbox = (new Map(): Map<string, boolean>);
        CartSaveds.map((register, index) => {
            newCheckbox.set(index, action)
        });
        this.setState({
            checkboxDataTables: newCheckbox
        });
    };

    closemodalestasSeguro = async response => {
        $('#estasSeguroModalOrder').modal('hide'); 
    }

    GenerateOrder = async (Id, CardCode, CardName) => {
        const {notificationReducer: { showAlert }, enableSpinner} = this.props;
        enableSpinner(true);

        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        let creator;
        if (Number(creatorUser.U_FMB_Handel_Perfil) === 1) {
            creator = "Telemarketing:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 2) {
            creator = "Vendedor:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 3) {
            creator = "Administrador:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        }else{
            creator = "B2B:" + CardName;
        }
        //Definicion del vendedor
        empID = empID ? empID.salesPerson : '';

        let data = {
            Id,
            CardCode,
            CardName,
            objType: '17',
            empID,
            creator,
            taxOnly: 0,
            venta: '01',
            Version : 'VerF: '+global.appVersion,                    
            creatorUser,
        };

        let response = await apiClient.createCartSaved(data);
        
        if(response.status === SERVICE_RESPONSE.SUCCESS){                    
            await apiClient.deleteCartSaved(Id);
            showAlert({ type: 'success', message: response.message ? response.message : '',timeOut: 5000 });
            this.table.destroy();
            this.cargarDatos();
        }else{
            showAlert({ type: 'error', message: response.message ? response.message : '' ,timeOut: 5000 });
        }
        enableSpinner(false);
        return;
    }

    download = () => {
        const { enableSpinner} = this.props;
        const { CartSaveds } = this.state;
        
        enableSpinner(true);
        let csvData = [];
        if(CartSaveds.length > 0){
            CartSaveds.map((data)=>{
                let row ={
                    'FECHA': moment(data.DateCart).format('DD-MM-YYYY'),
                    'CÓDIGO CLIENTE' : data.CardCode,
                    'CLIENTE' : data.CardName, 
                    'ZONA' : data.Zona, 
                    'DIRECCIÓN DE ENVÍO' : data.DirEnvio,
                    'PESO NETO' : parseFloat(data.PesoNeto > 0 ? data.PesoNeto : 0).toFixed(2),
                    'PESO EN' : 'KG',
                    'MONEDA' : 'S/',
                    'VALOR' : parseFloat(data.Valor > 0 ? data.Valor : 0).toFixed(2),
                }
                csvData.push(row);
            });

            this.setState({
                csvData,
            });
        }
        enableSpinner(false);
    };

    render() {
        const {history} = this.props;
        const {CartSaveds, order, fechaInicio, fechaFinal, fechaActual, checkboxDataTables,responseArray,csvData, csvDatas} = this.state; 
        
        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }
        
        return (
            <div className="content-fluid " style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.PROMO_VIEW}/>
                <NavBar/>
                <NotificationsModal
                responseArray ={responseArray}
                ></NotificationsModal>
            
                <div className="container mb-4" style={{paddingTop: 60, maxWidth:'1800px'}}>
                    <div className="row">
                        <div className="col">
                            <div className="jumbotron" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                <h1 className="display-6 text-center">Autogestión Clientes "carritos guardados"</h1>
                            </div>
                        </div>    
                    </div>
                    <br></br>
                    <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                        <div className=" row col-md-4">
                            <h4 className="pr-2">Desde:</h4>
                            <input 
                                id="fechaInicio"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechauno" 
                                max={fechaActual}
                                value = {fechaInicio}
                                onChange = {(event) => this.handleInputDateInicio(event)}/>
                        </div>
                        <div className="row col-md-4 pb-3">
                            <h4 className="pr-2">Hasta:</h4>
                            <input 
                                id="FechaFin"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechados" 
                                max={fechaActual}
                                value = {fechaFinal}
                                onChange = {(event) => this.handleInputDateFinal(event)}/>
                        </div>
                        <div className="col-md-2 pb-2">
                            <button
                                onClick={()=>this.getData()}
                                className="btn botonResumen" 
                                style={{
                                    backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                    color: config.navBar.textColorCategorieHover,
                                    fontWeight: "bold",
                                }}>
                                Ver pedidos
                            </button>
                        </div>
                    </div> 
                    <button type="button" class="btn btn-primary float-right" data-toggle="modal" data-target=".estasSeguro">Generar carritos masivamente</button>
                    <div className="table-responsive" style={{marginBottom: 0, height: 600, maxHeight: 600, overflow: 'auto'}}> 
                        <table id="AutoCartsSaved" className="table table-hover scrolltable" style={{marginRight: 0, marginLeft: 0}}>
                            <thead >
                                <tr className="text-light text-center" style={{background: '#2d75bd', borderRadius: '0'}} >
                                    <th scope="col" style={{width:'3%'}}>#</th>
                                    <th className="sticky-column" style={{width:'5%'}}>
                                        <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" value="second_checkbox"
                                            onChange={(event) => checkbox.selectAll(event.target.checked)}/>
                                    </th>
                                    <th scope="col" style={{width:'10%'}}>Fecha</th>
                                    <th scope="col" style={{width:'10%'}}>Código cliente</th>
                                    <th scope="col" style={{width:'20%'}}>Cliente</th>
                                    <th scope="col" style={{width:'9%'}}>Zona</th>
                                    <th scope="col" style={{width:'10%'}}>Dirección de envío</th>
                                    <th scope="col" style={{width:'10%'}}>Peso neto</th>
                                    <th scope="col" style={{width:'10%'}}>Valor</th>
                                    <th scope="col" style={{width:'5%'}}></th>
                                    <th scope="col" style={{width:'8%'}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {!!CartSaveds && CartSaveds.map((cart, index ) => {
                                    return(
                                        <tr className="text-center">
                                            <th scope="row" style={{width:'3%'}}>{index+1}</th>
                                            <td className="text-center" style={{width:'5%'}}>
                                                <input type="checkbox" style={{minWidth:'100%'}} id="cbox2"
                                                    checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)}/>
                                            </td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'10%'}}>{cart.DateCart}</td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'10%'}}>{cart.CardCode}</td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'20%'}}>{cart.CardName}</td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'9%'}}>{cart.Zona}</td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'10%'}}>{cart.DirEnvio}</td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'10%'}}>{ parseFloat(cart.PesoNeto > 0 ? cart.PesoNeto : 0).toFixed(2) + ' KG' }</td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'10%'}}> 
                                                <CurrencyFormat
                                                    value={cart.Valor > 0 ? cart.Valor : 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    decimalScale={2}
                                                    prefix={config.general.currency}>
                                                </CurrencyFormat>
                                            </td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'5%'}}>
                                                <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                    onClick={() => this.Details(cart.id, cart.Cart, cart.CardCode, cart.DirEnvio,cart)}> 
                                                   Visualizar
                                                </button>
                                            </td>
                                            <td style={{paddingLeft : '2px', paddingRight : '2px', width:'8%'}}>
                                                <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                    onClick={() => this.GenerateOrder(cart.id, cart.CardCode, cart.CardName)}> 
                                                   Generar Pedido
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <br></br>
                    {/* <div style={{display:CartSaveds.length > 0 ? 'block' : 'none' }}> */}
                        <CSVLink
                            className="btn btn-success float-left"
                            onClick={this.download}
                            style={{
                                color: config.navBar.textColorCategorieHover,
                                fontWeight: "bold",
                            }}
                            data={csvData} filename={"AutogestionClientes.csv"}>
                                Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                        </CSVLink>
                        <ExportReportPDFCardSaveds data={CartSaveds}></ExportReportPDFCardSaveds>
                    {/* </div>                     */}
                </div> 

                <div class="modal fade bd-example-modal-xl" id="autogestsave" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header text-light" style={{background: '#2d75bd', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Detalle de carrito</h4>

                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body bg3">
                                {order && order.length > 0 && order.map(item => {
                                    return <div key={item.ItemCode} className="row">
                                        <div className="col-md-3 text-center">
                                            <img className="img-fluid" style={{ backgroundColor: 'white', maxHeight: 130 }}
                                                src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../../images/noImage.png')}
                                                alt=""
                                            />
                                        </div>
                                        <div className="col-md-8 table-responsive">
                                            <div className="container p-0">
                                                <div className="row text-left">
                                                    <div className="col-md-12"  style={{borderBottom: '1px solid rgb(124, 124, 125)'}}>
                                                        {item.ItemName}
                                                    </div>
                                                </div>
                                                <div className="row font-weight-bold ">
                                                    <div className="col-md-3 text-center">
                                                        Código
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Cantidad
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Precio unitario
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Precio total
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 text-center">
                                                        {item.ItemCode}
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        {parseInt(item.Quantity)}
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        <CurrencyFormat
                                                            value={Number(item.Price) + Number((item.Price * (18 / 100)))}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={2}
                                                            prefix={config.general.currency}>
                                                        </CurrencyFormat>                                                        
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        <CurrencyFormat
                                                            value={(Number(item.Price) + Number((item.Price * (18 / 100)))) * parseInt(item.Quantity)}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={2}
                                                            prefix={config.general.currency}>
                                                        </CurrencyFormat>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                                
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                                <CSVLink
                                    className="btn btn-success float-right"
                                    data={csvDatas} filename={"Autogestion_Carrito.csv"}>
                                        Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                                </CSVLink>
                                <button type="button" className="btn btn-success" onClick={()=> this.addToShopingCart()}>
                                    <i className="fas fa-cart-plus"/>
                                    &nbsp; Agregar al carrito
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade estasSeguro" tabindex="-1" role="dialog" id="estasSeguroModalOrder" >
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                        <div class="modal-header" style={{background: '#2d75bd', borderRadius: '0',color:'white'}}>
                            <h5 class="modal-title">Mensaje de alerta.</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>                            
                            </button>
                        </div>
                        <div class="modal-body">
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    <h4>¿Estas seguro que deseas crear las ordenes de venta de los carrito guardados masivamente?</h4>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={this.closemodalestasSeguro}>Cerrar</button>
                            <button type="button" className="btn btn-success" onClick={()=>this.GenerateOrderMasive()}> Crear los carritos </button>                            
                        </div>
                        </div>
                    </div>
                </div>
            </div>            
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setRememberUser: value =>  dispatch({type: DISPATCH_ID.SESSION_SET_REMEMBER_USER, value}),
        setUserSession: value => dispatch({type: DISPATCH_ID.SESSION_SET_USER, value}),
        setRole: value => dispatch({type: DISPATCH_ID.SESSION_SET_ROLE, value}),
        setToken: value => dispatch({type: DISPATCH_ID.SESSION_SET_TOKEN, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutoGestCartSavedView);

